/* Progressive enhancements. Every room and product link works without JS. */
(()=>{
  const init=root=>{
    if(root.dataset.wnfeReady)return;root.dataset.wnfeReady='true';
    const body=root.querySelector('#wnf-article-body'),toc=root.querySelector('#wnf-toc'),list=root.querySelector('#wnf-toc-list');
    if(body&&toc&&list){
      const headings=[...body.querySelectorAll('h2')];
      if(headings.length>1){
        const ids=new Set([...document.querySelectorAll('[id]')].map(e=>e.id));
        headings.forEach((h,i)=>{
          if(!h.id){let id=`wnfe-section-${i+1}`;while(ids.has(id))id+='-';h.id=id;ids.add(id);}
          const li=document.createElement('li'),a=document.createElement('a');a.href=`#${h.id}`;a.textContent=h.textContent;li.append(a);list.append(li);
        });toc.hidden=false;toc.style.display='block';
      }
      body.querySelectorAll('table').forEach(table=>{if(table.parentElement.classList.contains('wnfe-table-wrap'))return;const wrap=document.createElement('div');wrap.className='wnfe-table-wrap';wrap.tabIndex=0;wrap.setAttribute('role','region');wrap.setAttribute('aria-label','Scrollable table');table.before(wrap);wrap.append(table);});
    }
    root.addEventListener('click',event=>{
      if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      const a=event.target.closest?.('a[href^="#"]');if(!a)return;
      const target=document.getElementById(a.hash.slice(1));if(!target||!root.contains(target))return;
      event.preventDefault();event.stopPropagation();
      history.pushState(null,'',a.hash);target.tabIndex=-1;target.focus({preventScroll:true});
      target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    },{capture:true});
    root.querySelectorAll('[data-wnfe-tag-select]').forEach(s=>s.addEventListener('change',()=>{if(s.value)location.assign(s.value);}));
  };
  const scan=()=>document.querySelectorAll('[data-wnfe]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
})();
